function checkboxCalculation() {
    const crossSells = document.querySelectorAll('.cross-sell-box-section');
    const selectedCrossSells = Array.from(crossSells).filter(crossSell => {
        const checkbox = crossSell.querySelector('input[type="checkbox"]');
        return checkbox && checkbox.checked;
    });

    let totalPrice = 0;
    selectedCrossSells.forEach(crossSell => {
        const checkbox = crossSell.querySelector('input[type="checkbox"]');
        const price = parseFloat(checkbox.getAttribute('data-price'));
        totalPrice += price;
    });

    const cartTotalValue = document.querySelector('.cart-total-value');
    if (cartTotalValue) {
        const currentPrice = parseFloat(cartTotalValue.getAttribute('data-product-price'));
        totalPrice += currentPrice;
    }

    const currency = cartTotalValue.getAttribute('data-currency');
    document.querySelector('.cart-total-value').innerHTML = `${currency}${totalPrice.toFixed(2)}`;
}

function onCrossSellClickHandler(evt) {
    checkboxCalculation();
}

document.addEventListener('DOMContentLoaded', function () {
    checkboxCalculation();

    const crossSells = document.querySelectorAll('.cross-sell-box-section');
    crossSells.forEach(crossSell => {
        const checkbox = crossSell.querySelector('input[type="checkbox"]');
        checkbox.addEventListener('click', onCrossSellClickHandler);
    });
});
